import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SiteFooter from "./SiteFooter";
import { isAuthenticated, getUser, clearAuth } from "../utils/auth";
import { 
  Calculator, 
  Compass, 
  BookOpen, 
  Calendar, 
  Users, 
  Sun, 
  Moon,
  Search,
  User,
  LogOut,
  Settings
    } from "lucide-react";/**
 * 首页（Index）
 * - 介绍网站定位与功能模块
 * - 移动端友好的网格布局
 * - 无图片设计，使用图标和色块
 */
const Indexmain = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (isAuthenticated()) {
      setUser(getUser());
    }
  }, []);

  const handleLogout = () => {
    clearAuth();
    setUser(null);
    window.location.reload();
  };

  const cards = [
    {
      id: "bazi",
      title: "八字排盘",
      desc: "四柱八字、藏干与基本用神分析",
      route: "/bazi/index",
      icon: <Calculator className="w-6 h-6 sm:w-8 sm:h-8 text-indigo-600" />,
      color: "bg-indigo-50 border-indigo-100",
      textColor: "text-indigo-600"
    },
    {
      id: "liuyao",
      title: "六爻排盘",
      desc: "传统六爻起卦、断卦与保存",
      route: "/liuyao/index",
      icon: <Compass className="w-6 h-6 sm:w-8 sm:h-8 text-purple-600" />,
      color: "bg-purple-50 border-purple-100",
      textColor: "text-purple-600"
    },
    {
      id: "qimen",
      title: "奇门遁甲",
      desc: "奇门排盘与决策分析",
      route: "/qimen/index",
      icon: <Search className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600" />,
      color: "bg-blue-50 border-blue-100",
      textColor: "text-blue-600"
    },

    {
      id: "zeri-mobile",
      title: "奇门择吉",
      desc: "挑选良辰吉日，趋吉避凶",
      route: "/zeri/mobile",
      icon: <Calendar className="w-6 h-6 sm:w-8 sm:h-8 text-orange-600" />,
      color: "bg-orange-50 border-orange-100",
      textColor: "text-orange-600"
    },
    {
      id: "horseyear",
      title: "马年指南",
      desc: "2026丙午马年犯太岁详解",
      route: "/horseyear",
      icon: <Calendar className="w-6 h-6 sm:w-8 sm:h-8 text-amber-600" />,
      color: "bg-amber-50 border-amber-100",
      textColor: "text-amber-600"
    },
    {
      id: "daily",
      title: "每日运程",
      desc: "老黄历与每日宜忌运势",
      route: "/lunarcalendar",
      icon: <Sun className="w-6 h-6 sm:w-8 sm:h-8 text-red-600" />,
      color: "bg-red-50 border-red-100",
      textColor: "text-red-600"
    },
    {
      id: "fengshui",
      title: "八宅风水",
      desc: "居家风水布局与九星分析",
      route: "/fengshui",
      icon: <Moon className="w-6 h-6 sm:w-8 sm:h-8 text-teal-600" />,
      color: "bg-teal-50 border-teal-100",
      textColor: "text-teal-600"
    },

    {
      id: "zhishiku",
      title: "知识库",
      desc: "易学基础知识与案例查询",
      route: "https://books.tryonebest.com/",
      external: true,
      icon: <BookOpen className="w-6 h-6 sm:w-8 sm:h-8 text-emerald-600" />,
      color: "bg-emerald-50 border-emerald-100",
      textColor: "text-emerald-600"
    },

    {
      id: "booking",
      title: "预约命理师",
      desc: "专业命理师一对一咨询服务",
      route: "/fufeiyuyue",
      icon: <Users className="w-6 h-6 sm:w-8 sm:h-8 text-pink-600" />,
      color: "bg-pink-50 border-pink-100",
      textColor: "text-pink-600"
    },
  ];

  // 处理卡片点击 - 直接跳转页面
  const handleCardClick = (card) => {
    if (card.external) {
      window.open(card.route, "_blank", "noopener,noreferrer");
      return;
    }
    navigate(card.route);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Hero Section */}
      <header className="relative bg-gradient-to-br from-indigo-700 to-purple-800 text-white pb-12 pt-16 px-6 rounded-b-[2rem] shadow-lg">
        {/* Login/User Button */}
        <div className="absolute top-6 right-6 flex items-center gap-3">
          {user ? (
            <>
              <a 
                href="/portal"
                className="px-4 py-2 hover:text-indigo-200 transition-all text-sm font-medium"
              >
                广 场
              </a>
                 <button
                  onClick={() => navigate('/yunying/yunying')}
                  className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full transition-all text-sm font-medium"
                >
                  <Settings className="w-4 h-4" />
                  <span className="hidden sm:inline">管理员入口</span>
                </button>
             

              <button 
                onClick={() => navigate('/yunying/userinfo')}
                className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full transition-all text-sm font-medium"
              >
                <User className="w-4 h-4" />
                <span className="hidden sm:inline">{user?.nickname || '个人中心'}</span>
              </button>
              
              <button 
                onClick={handleLogout}
                className="p-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full transition-all text-white"
                title="退出登录"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <>
              <button 
                onClick={() => navigate('/login')}
                className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full transition-all text-sm font-medium"
              >
                <User className="w-4 h-4" />
                <span>登录 / 注册</span>
              </button>
              <a 
                href="/portal"
                className="px-4 py-2 hover:text-indigo-200 transition-all text-sm font-medium"
              >
                发布广场
              </a>
              <a 
                href="/"
                className="px-4 py-2 hover:text-indigo-200 transition-all text-sm font-medium"
              >
                排盘
              </a>
            </>
          )}
        </div>

        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl font-bold mb-4 tracking-tight">
            圆 運
          </h1>
          <p className="text-indigo-100 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed opacity-90">
            探索传统易学智慧，指引现代生活决策
          </p>
        </div>
      </header>

      {/* Main Content - Offset Grid */}
      <main className="flex-grow px-4 -mt-8 pb-12">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-3 gap-2 sm:grid-cols-2 lg:grid-cols-4 sm:gap-4">
            {cards.map((card) => (
              <div
                key={card.id}
                onClick={() => handleCardClick(card)}
                className={`
                  relative overflow-hidden
                  bg-white rounded-lg sm:rounded-xl p-2 sm:p-6
                  border ${card.color}
                  shadow-sm hover:shadow-md
                  transition-all duration-300 transform hover:-translate-y-1
                  cursor-pointer
                  flex flex-col items-center text-center
                  justify-center sm:justify-start aspect-square sm:aspect-auto
                `}
              >
                <div className={`p-2 sm:p-3 rounded-full mb-1 sm:mb-4 ${card.color} bg-opacity-50`}>
                  {card.icon}
                </div>
                
                <h3 className="text-xs sm:text-lg font-bold text-gray-900 mb-0 sm:mb-2">
                  {card.title}
                </h3>
                <p className="hidden sm:block text-sm text-gray-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            ))}
          </div>


        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export default Indexmain;